import { SeoHead } from "@/components/SeoHead"
import { MarketingLayout } from "@/components/marketing/MarketingLayout"
import { Section } from "@/components/marketing/sections/Section"

const DESCRIPTION =
  "How FullCast collects, uses, and protects the information you share through this website and the application form."

export default function Privacy() {
  return (
    <MarketingLayout>
      <SeoHead title="Privacy Policy" description={DESCRIPTION} />

      <Section containerClassName="max-w-3xl">
        <h1 className="display-2">Privacy Policy</h1>
        <p className="mt-3 text-sm text-ink-muted">Last updated: 2026</p>

        <div className="callout callout-signal mt-6 text-sm">
          This is placeholder legal copy. Have it reviewed by a qualified
          professional and tailored to FullCast before launch.
        </div>

        <div className="body-content mt-8">
          <p>
            FullCast ("we", "us") respects your privacy. This policy explains what
            information we collect through this website, how we use it, and the
            choices you have.
          </p>
          <h2>Information we collect</h2>
          <p>
            We collect the information you provide when you submit the application
            form — such as your name, email address, business details, and your
            responses to qualifying questions. We also collect basic, privacy-
            friendly analytics about how the site is used.
          </p>
          <h2>How we use information</h2>
          <p>
            We use your information to evaluate fit for the FullCast Podcast Growth
            Partnership, to contact you about your application, and to improve our
            services. We do not sell your personal information.
          </p>
          <h2>How information is shared</h2>
          <p>
            We rely on trusted service providers — for scheduling, email delivery,
            and analytics — who process information on our behalf and only as
            needed to provide those services.
          </p>
          <h2>Your choices</h2>
          <p>
            You may request access to, correction of, or deletion of your personal
            information at any time by contacting us.
          </p>
          <h2>Contact</h2>
          <p>
            Questions about this policy, or want to access, correct, or delete your
            information? Reach us through our <a href="/apply">contact form</a>.
          </p>
        </div>
      </Section>
    </MarketingLayout>
  )
}
